"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableBaseFieldsSchema = exports.AssignmentExclusionSchema = exports.AssignmentExclusionIterable = exports.AssignmentFieldsSchema = exports.receivableRetroEvent = exports.ReceivableStatus = exports.ReceivableStatusIterable = void 0;
const zod_1 = require("zod");
const Utils_1 = require("../Utils");
exports.ReceivableStatusIterable = ['assigned', 'unassigned'];
exports.ReceivableStatus = {
    Assigned: 'assigned', // assigned to CF
    Unassigned: 'unassigned', // assigned to master (parent)
};
exports.receivableRetroEvent = [
    'retro-originate',
    'retro-assign',
    'retro-unassign',
];
const receivableNominalEvent = [
    'originate',
    'assign',
    'unassign',
    'transfer',
];
exports.AssignmentFieldsSchema = zod_1.z.object({
    assignedAt: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    fileVersion: zod_1.z.number(),
    purchasePrice: zod_1.z.number().optional(),
    purchasePercentageRate: zod_1.z.number().optional(),
});
exports.AssignmentExclusionIterable = ['none', 'soft', 'hard'];
exports.AssignmentExclusionSchema = zod_1.z.enum(exports.AssignmentExclusionIterable);
// Zod schema for ReceivableBaseFields - record of string to Primitive
exports.ReceivableBaseFieldsSchema = zod_1.z.record(zod_1.z.string(), Utils_1.PrimitiveStruct);
//# sourceMappingURL=common.js.map